var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoImageSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 62,
    viewBox: "0 0 83 62",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-318.000000, -268.000000) translate(320.000000, 270.000000)",
    stroke: "currentColor",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3377881 36.2270054L24.9303383 16.8613852 41.5608285 42.0363455 52.9822886 31.3120754 61.6547787 43.6262155"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.114812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.5052397,19.1450452 C65.5052397,21.5410952 63.5624497,23.4821553 61.1663997,23.4821553 C58.7703496,23.4821553 56.8275596,21.5410952 56.8275596,19.1450452 C56.8275596,16.7472652 58.7703496,14.8062052 61.1663997,14.8062052 C63.5624497,14.8062052 65.5052397,16.7472652 65.5052397,19.1450452 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2517138,57.0901736 L3.46017304,57.0901736 C1.54852302,57.0901736 0.000173000002,55.5400936 0.000173000002,53.6301736 L0.000173000002,4.07432304 C0.000173000002,2.16440302 1.54852302,0.614323007 3.46017304,0.614323007 L75.2517138,0.614323007 C77.1616339,0.614323007 78.7117139,2.16440302 78.7117139,4.07432304 L78.7117139,53.6301736 C78.7117139,55.5400936 77.1616339,57.0901736 75.2517138,57.0901736 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImageSvg);
export default __webpack_public_path__ + "static/media/no-image-svg.703d8fdb09e08455ae13aecf513bef17.svg";
export { ForwardRef as ReactComponent };